module.exports = __webpack_public_path__ + "static/media/chatty-time.77611963.png";